import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './views/Header';
import Home from './views/Home';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Path } from './utils/path';
import Footer from './views/Footer';
import { ConfirmProvider } from './components/ConfirmProvider';

import './i18n/index';
import Portfolio from './views/portfolio/Portfolio';
import PortfolioStageArt from './views/portfolio/PortfolioStageArt';
import PortfolioBinanceBot from './views/portfolio/PortfolioBinanceBot';
import PortfolioZloteMysli from './views/portfolio/PortfolioZloteMysli';
import About from './views/About';
import PortfolioFrat from './views/portfolio/PortfolioFrat';

const AnimatedRoutes: React.FC = () => {
  const location = useLocation();

  const direction = location.state?.direction === 'back' ? -1 : 1;

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path={Path.HOME} element={<PageWrapper direction={direction}><Home /></PageWrapper>} />
        <Route path={Path.ABOUT} element={<PageWrapper direction={direction}><About /></PageWrapper>} />
        <Route path={Path.PORTFOLIO} element={<PageWrapper direction={direction}><Portfolio /></PageWrapper>} />
        <Route path={Path.STAGE_ART} element={<PageWrapper direction={direction}><PortfolioStageArt /></PageWrapper>} />
        <Route path={Path.FRAT} element={<PageWrapper direction={direction}><PortfolioFrat /></PageWrapper>} />
        <Route path={Path.BINANCE_BOT} element={<PageWrapper direction={direction}><PortfolioBinanceBot /></PageWrapper>} />
        <Route path={Path.ZLOTE_MYSLI} element={<PageWrapper direction={direction}><PortfolioZloteMysli /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

const PageWrapper: React.FC<{ children: React.ReactNode, direction: number }> = ({ children, direction }) => (
  <motion.div
    initial={{ x: 100 * direction, opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    exit={{ x: -100 * direction, opacity: 0 }}
    transition={{ duration: .2, ease: 'easeInOut' }}
    className="w-full h-full flex flex-col items-center flex-1"
  >
    {children}
  </motion.div>
);

const App: React.FC = () => {

  const toggleDarkMode = () => {
    const html = document.documentElement;
    if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }
  };

  useEffect(() => {
    toggleDarkMode();
  }, []);

  return (
    <BrowserRouter>
      <ConfirmProvider>
        <div className="min-h-screen flex flex-col">
          <Header />
          <main className="flex-1 flex flex-col items-center w-full overflow-x-hidden">
            <AnimatedRoutes />
          </main>
          <Footer />
        </div>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </ConfirmProvider>
    </BrowserRouter>
  );
};

export default App;